module.exports = __webpack_public_path__ + "static/img/activity6.531fe14.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weicai/aboutWe/activity6.jpg
// module id = NEwv
// module chunks = 3